"use client";

import { useEffect, useRef, useState } from "react";
import Link from "next/link";
import { Menu, X, Phone, MessageCircle } from "lucide-react";
import { NAV_LINKS, SITE } from "../lib/site";

export default function MobileMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  return (
    <div className="relative md:hidden" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label={open ? "Cerrar menú" : "Abrir menú"}
        className="inline-flex size-10 items-center justify-center rounded-full border border-border bg-white text-brand-900 transition hover:bg-brand-50"
      >
        {open ? <X className="size-5" /> : <Menu className="size-5" />}
      </button>

      {open && (
        <div className="absolute right-0 top-12 z-50 w-56 rounded-2xl border border-border bg-white shadow-xl">
          <nav className="flex flex-col p-2" aria-label="Menú móvil">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-xl px-4 py-2.5 text-sm font-semibold text-brand-900 transition hover:bg-brand-50"
              >
                {link.label}
              </Link>
            ))}
          </nav>
          <div className="border-t border-border p-2 flex flex-col gap-2">
            <a
              href={SITE.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-flame-600 px-4 py-2.5 text-sm font-bold text-white hover:bg-flame-700"
            >
              <MessageCircle className="size-4" />
              WhatsApp
            </a>
            <a
              href={`tel:${SITE.phone}`}
              onClick={() => setOpen(false)}
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-border px-4 py-2.5 text-sm font-semibold text-brand-900 hover:bg-brand-50"
            >
              <Phone className="size-4" />
              Llamar
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
